module.exports = __webpack_public_path__ + "static/img/00_mxbc.cfd0cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessPlatform/swiperImg/firstLine/00_mxbc.png
// module id = +VBV
// module chunks = 0